import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface CreateAiSummaryPayload {
  document_id: string;
  revision_id?: number | null;
  /**
   * Free-text style and focus instruction. Not an export template: those are a
   * separate feature, and referencing one by id let a caller apply another
   * organization's private prompt.
   */
  style_prompt?: string | null;
}

export interface AiSummaryJob {
  job_id: string;
  status: string;
  progress: number;
  ai_generated: boolean;
  pipeline_version: string;
  model_version: string | null;
  review_state: string;
  created_at: string;
  date_started: string | null;
  date_completed: string | null;
  detected_language: string | null;
  output_language: string | null;
  result: {
    summary: string;
    key_decisions: Array<{ text: string; source_refs: number[] }>;
    action_items: Array<{
      text: string;
      owner: string;
      due_date: string;
      source_refs: number[];
    }>;
    open_questions: string[];
    output_language: string | null;
    coverage: { total: number; processed: number } | null;
  } | null;
  error_message: string | null;
  source_revision_id: number | null;
  quota: {
    enabled: boolean;
    limit: number | null;
    used: number;
    reserved: number;
    remaining: number | null;
    reset_at: string | null;
  } | null;
}

export const useCreateAiSummary = () => {
  return useMutation<AiSummaryJob, AxiosError, CreateAiSummaryPayload>(
    async payload => {
      const response = await Axios.post(POST_URL().createAiSummary, payload);
      return response.data;
    }
  );
};
